import { render, staticRenderFns } from "./EachTopicPictureComponent.vue?vue&type=template&id=b9822680&"
import script from "./EachTopicPictureComponent.vue?vue&type=script&lang=js&"
export * from "./EachTopicPictureComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports